export default "__VITE_ASSET__3rr_3qKr__"